import { useStoreState } from 'providers/StoreStateContext';
import { useLocation } from 'react-router-dom';

export const useFormSave = () => {
  const { musicProductDigitalForm, musicProductPhysicalForm, trackForm, videoForm, artistForm } =
    useStoreState();

  const { pathname } = useLocation();

  const isAnyFormSaved =
    !!musicProductDigitalForm ||
    !!musicProductPhysicalForm ||
    !!trackForm ||
    !!videoForm ||
    !!artistForm;

  const announcementDisplay =
    !(pathname.includes('create') || pathname.includes('edit')) && isAnyFormSaved;

  return { isAnyFormSaved, announcementDisplay };
};
